import { render } from "./blog-1.vue?vue&type=template&id=ad8b0f50"
import script from "./blog-1.vue?vue&type=script&lang=js"
export * from "./blog-1.vue?vue&type=script&lang=js"

import "./blog-1.vue?vue&type=style&index=0&id=ad8b0f50&lang=less"

import exportComponent from "/var/jenkins_home/workspace/give-circle-intro/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__